/* eslint-disable jsx-a11y/media-has-caption */
import React, { useContext } from "react";
import { bool, node, oneOf, string } from "prop-types";
import { classes } from "../utils/classes";
import AssetsProvider from "../utils/AssetsProvider";

const Video = ({
	isBaseUrl = true,
	srcMP4,
	srcWEBM = "",
	poster,
	controls = false,
	loop = true,
	playsInline = true,
	autoPlay = true,
	muted = true,
	preload = "auto",
	children = null,
	className = "",
	frame = false,
	...props
}) => {
	const baseUrl = isBaseUrl ? useContext(AssetsProvider.context) : "";

	return (
		<video
			className={classes("video", frame && "video--frame", className)}
			controls={controls}
			autoPlay={autoPlay}
			loop={loop}
			playsInline={playsInline}
			muted={muted}
			poster={`${baseUrl}${poster}`}
			preload={preload}
			{...props}
		>
			<source type="video/mp4" src={`${baseUrl}${srcMP4}`} />
			{srcWEBM ? <source type="video/webm" src={`${baseUrl}${srcWEBM}`} /> : null}
			{children}
			Your browser does not support the video tag.
		</video>
	);
};

Video.propTypes = {
	isBaseUrl: bool,
	srcMP4: string.isRequired,
	srcWEBM: string,
	poster: string.isRequired,
	className: string,
	controls: bool,
	autoPlay: bool,
	loop: bool,
	playsInline: bool,
	preload: oneOf(["none", "auto", "metadata"]),
	muted: bool,
	frame: bool,
	children: node,
};

export default Video;
